
import { defineComponent, computed } from 'vue'
import { MqResponsive } from 'vue3-mq'

import AsHeaderMobile from '@web/components/headers/AsHeaderMobile.vue'
import AsHeaderMain from '@web/components/headers/AsHeaderMain.vue'
import AsMenu from '@web/components/AsMenu.vue'
import AsSpacer from '@web/components/AsSpacer.vue'
import AsFooter from '@web/components/AsFooter.vue'
import AsBreadcrumb from '@web/components/AsBreadcrumb.vue'
import Subscriptions from '@web/components.v2/Subscriptions/index.vue'
import AsRow from '@web/components/AsRow.vue'

import i18n from '@web/plugins/i18n'
import { useStore } from '@web/store'
import { useMeta } from '@web/common/vueMeta'

export default defineComponent({
  name: 'VSubscriptions',
  components: {
    MqResponsive,
    AsHeaderMobile,
    AsHeaderMain,
    AsMenu,
    AsSpacer,
    AsFooter,
    AsBreadcrumb,
    Subscriptions,
    AsRow
  },
  setup () {
    const store = useStore()

    const title = i18n.global.t('Subscriptions')
    const menu = computed(() => store.getters['menu/general'])
    useMeta({
      title
    })

    return {
      title,
      menu
    }
  }
})
